import { render, staticRenderFns } from "./Stocks.vue?vue&type=template&id=767bef70&scoped=true"
import script from "./Stocks.vue?vue&type=script&lang=js"
export * from "./Stocks.vue?vue&type=script&lang=js"
import style0 from "./Stocks.vue?vue&type=style&index=0&id=767bef70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767bef70",
  null
  
)

export default component.exports